require('./scheduledTransfersContentTableInfoRow.scss');

// @ vendor
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, FormattedText, formatTextApi, getLanguage } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { getIntervenersNames } = require('utilities/transfersHelper');
const DateHelper = require('utilities/dateHelper');

// @ actions
const scheduledTransfersDetailsActions = require('actions/scheduledTransfersDetails');

// @ commons
const { LabelDate } = require('commonsComponents/labelDate');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const ScheduledTransfersOptionsButtons = require('components/transfers/scheduled/scheduledTransfersOptionsButtons/scheduledTransfersOptionsButtons');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const WebappRender = require('components/conditionalRender/webappRender')

// @ constants
const { getTranslatedCountry } = require('constants/countries');
const { HYPHEN, TRANSFER_EMITTED_DAY_AFTER, TRANSFER_EMITTED_DAY_BEFORE } = require('constants/index');
const INVALID_PRODUCT_NUMBER = '696';
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');


class ScheduledTransfersContentTableInfoRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColumns: document.getElementsByClassName('transfers-landing-view__main-content').length ? 1 : 2
        }
    }

    componentDidMount() {
        const { immTransaction, getScheduledTransfersDetails } = this.props;
        const accountId = immTransaction.get('accountId');

        if (!immTransaction.get('details') && immTransaction.getIn(['extra', 'product']) !== INVALID_PRODUCT_NUMBER) {
            const scheduledTransfersId = immTransaction.get('id');
            getScheduledTransfersDetails(accountId, scheduledTransfersId);
        }
    }

    buildRow(titleKey, value){
        const title = !!titleKey ? formatText(titleKey) : '';
        return (
            <OKTableRowDetailsItem title={title} value={value} />
        );
    }

    getExecutionDate(immDetails) {
        let executionDate = HYPHEN;
        const originalNextExecutionDate = immDetails.get('originalNextExecutionDate');
        const nextExecutionDate = immDetails.get('nextExecutionDate');

        if (originalNextExecutionDate.isValid() && originalNextExecutionDate.year() !== 9999) {
            executionDate = DateHelper.formatDate(originalNextExecutionDate, 'DATE_FORMAT');
        } else if (nextExecutionDate.isValid()) {
            executionDate = DateHelper.formatDate(nextExecutionDate, 'DATE_FORMAT');
        }
        return executionDate;
    }

    render() {
        const { id, immAccounts, immScreen, immTransaction } = this.props;
        const { displayColumns } = this.state;
        const immDetails = immTransaction.get('details');
        const isMobile = immScreen.get('isMobile');
        const loadingRowClasses = classNames({ 'transfers-table-info-row' : !isMobile }, 'container-fluid' );

        if (immTransaction.getIn(['extra', 'product']) === INVALID_PRODUCT_NUMBER) {
            return (
                <OKTableRow id={id}>
                    <OKTableCell colSpan={7}>
                        <p className="transfers-table-info-row__invalid-product-message">
                            <FormattedText value="transfersScheduled-invalidProductMessage" />
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        }

        if (!immDetails) {
            return (
                <OKTableRow id={id}>
                    <OKTableCell colSpan={7}>
                        <article className={loadingRowClasses}>
                            <LoadingSection />
                        </article>
                    </OKTableCell>
                </OKTableRow>
            );
        }

        const accountId = immTransaction.get('accountId');
        const immInterveners = immAccounts.getIn(['byId', accountId, 'interveners', 'list']);
        const immEmitter = immTransaction.get('emitter');
        const immPayer = immTransaction.get('payer');
        const intervenersNames = getIntervenersNames(immInterveners, immPayer, immEmitter);
        const tableRowTitle = !isMobile ? 'transfersEmited-detailInformation' : '';
        const tableRowColumns = isMobile ? 1 : 2;
        const treatmentNonWorkableDayValue = immDetails.get('treatmentNonWorkableDay') === TRANSFER_EMITTED_DAY_BEFORE
            ? formatText('transfersScheduled-before')
            : immDetails.get('treatmentNonWorkableDay') === TRANSFER_EMITTED_DAY_AFTER
            ? formatText('transfersScheduled-after')
            : HYPHEN;
        const language = getLanguage();

        const transferType = this.buildRow( 'transfersScheduled-transferType', formatTextApi('transfersScheduled-transferType', toFirstUppercase(immTransaction.get('transferType'))));
        const concept = isMobile ? null : this.buildRow( 'transfersScheduled-concept', immTransaction.get('concept') || HYPHEN );
        const name = this.buildRow( 'transfersScheduled-beneficiaryName', immDetails.get('name') );
        const treatmentNonWorkableDay = this.buildRow( 'transfersScheduled-treatmentNonWorkableDay', treatmentNonWorkableDayValue );
        const beneficiaryAccount = this.buildRow( 'transfersScheduled-beneficiaryAccount', immDetails.get('beneficiaryFullIban') );
        const paymentDestinationCountry = this.buildRow( 'transfersScheduled-paymentDestinationCountry', getTranslatedCountry(immDetails.getIn(['beneficiaryIban', 'pais'])) );

        let transferIntervenerFirstItem;
        let transferIntervenerSecondItem;
        let startDateData;
        let startDate;
        let endDateData;
        let endDate;
        let actionButtonsData;
        let actionButtons;

        if (isMobile) {
            startDateData = (
                <LabelDate
                    date={immTransaction.get('startDate')}
                    language={language}
                    today={LABEL_DATE_TODAY}
                    yesterday={LABEL_DATE_YESTERDAY}
                />
            );
            startDate = this.buildRow(
                'transfersScheduled-startDate',
                startDateData,
            );

            if (immTransaction.get('endDate').year() === 9999) {
                endDateData = (<FormattedText value="transfersScheduled-endDateUndefined" />);
            } else {
                endDateData = (
                    <LabelDate
                        date={immTransaction.get('endDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                );
            }

            endDate = this.buildRow(
                'transfersScheduled-endDate',
                endDateData,
            );

            actionButtonsData = (
                <WebappRender>
                    <ScheduledTransfersOptionsButtons
                        immTransaction={immTransaction}
                        isMobile={isMobile}
                    />
                </WebappRender>
            );

            actionButtons = this.buildRow(null, actionButtonsData);
        }

        if (!!intervenersNames.payerName) {
            transferIntervenerFirstItem = this.buildRow(
                'transferSummary-step2TransferEmitter',
                intervenersNames.payerName,
            );
            transferIntervenerSecondItem = this.buildRow(
                'transferSummary-step2TransferPayer',
                intervenersNames.emitterName || HYPHEN,
            );
        } else {
            transferIntervenerFirstItem = this.buildRow(
                'transferSummary-step2TransferPayer',
                intervenersNames.emitterName || HYPHEN,
            );
        }

        const executionDate = this.getExecutionDate(immDetails);
        const nextExecutionDateContent = this.buildRow( 'transfersScheduled-nextExecutionDate', executionDate );

        return (
            <OKTableRow id={id}>
                <OKTableCell />
                <OKTableCell colSpan={6}>
                    <OKTableRowDetails
                        isMobile={isMobile}
                        title={tableRowTitle}
                        columns={(!__CONTACT_CENTER__) ? tableRowColumns : displayColumns}
                    >
                        {startDate}
                        {endDate}
                        {transferType}
                        {transferIntervenerFirstItem}
                        {transferIntervenerSecondItem}
                        {concept}
                        {nextExecutionDateContent}
                        {name}
                        {treatmentNonWorkableDay}
                        {beneficiaryAccount}
                        {paymentDestinationCountry}
                        {actionButtons}
                    </OKTableRowDetails>
                </OKTableCell>
            </OKTableRow>
        );
    }
}

ScheduledTransfersContentTableInfoRow.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    getScheduledTransfersDetails: PropTypes.func.isRequired
};

module.exports.constructor = ScheduledTransfersContentTableInfoRow;
module.exports.ScheduledTransfersContentTableInfoRow = connect(
    state => ({
        immAccounts: state.accounts,
        immScreen: state.screen,
    }),
    {
        getScheduledTransfersDetails: scheduledTransfersDetailsActions.getScheduledTransfersDetails
    }
)(ScheduledTransfersContentTableInfoRow);
